import { marginChangeRequestApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

import { extractErrorMessage } from '../marginCenter.actionUtils';

export const CHANGE_REQUEST_ACTION_TYPE = createNamedActions('marginCenter/changeRequest', {
  SET_PENDING_LOADING: 'SET_PENDING_LOADING',
  SET_PENDING_ERROR: 'SET_PENDING_ERROR',
  GET_PENDING_CHANGE_REQUESTS: 'GET_PENDING_CHANGE_REQUESTS',
  SET_HISTORY_LOADING: 'SET_HISTORY_LOADING',
  SET_HISTORY_ERROR: 'SET_HISTORY_ERROR',
  GET_CHANGE_REQUEST_HISTORY: 'GET_CHANGE_REQUEST_HISTORY',
  SET_DECISION_SAVING: 'SET_DECISION_SAVING',
  SET_DECISION_ERROR: 'SET_DECISION_ERROR',
  RESOLVE_CHANGE_REQUEST: 'RESOLVE_CHANGE_REQUEST',
  CLEAR_DECISION_ERROR: 'CLEAR_DECISION_ERROR',
});

export const getPendingChangeRequestsAction = () => async dispatch => {
  dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.SET_PENDING_LOADING, payload: true });

  try {
    const { data } = await marginChangeRequestApi.getPending();

    return dispatch({
      type: CHANGE_REQUEST_ACTION_TYPE.GET_PENDING_CHANGE_REQUESTS,
      payload: data,
    });
  } catch {
    return dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.SET_PENDING_ERROR });
  }
};

export const getChangeRequestHistoryAction =
  (filters = {}) =>
  async dispatch => {
    dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.SET_HISTORY_LOADING, payload: true });

    try {
      const { data } = await marginChangeRequestApi.getHistory(filters);

      return dispatch({
        type: CHANGE_REQUEST_ACTION_TYPE.GET_CHANGE_REQUEST_HISTORY,
        payload: data,
      });
    } catch {
      return dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.SET_HISTORY_ERROR });
    }
  };

// DEV-5472: a requester withdraws their own still-Pending request. Requester != acting user 409s
// server-side and surfaces inline. On success the row leaves the pending queue (RESOLVE) — the caller
// refetches history so the withdrawn row appears there.
export const withdrawChangeRequestAction = (marginChangeRequestId, note) => async dispatch => {
  dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.SET_DECISION_SAVING, payload: true });

  try {
    const { data } = await marginChangeRequestApi.withdraw(marginChangeRequestId, note);

    dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.RESOLVE_CHANGE_REQUEST, payload: data });

    return data;
  } catch (error) {
    dispatch({
      type: CHANGE_REQUEST_ACTION_TYPE.SET_DECISION_ERROR,
      payload: extractErrorMessage(error),
    });

    return null;
  }
};

// Approve executes the guarded activation server-side (requester != approver, enforced there — a
// self-approval attempt 400s and surfaces inline rather than silently "succeeding"). Returns the decided
// row on success, null on failure.
export const approveChangeRequestAction = (marginChangeRequestId, note) => async dispatch => {
  dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.SET_DECISION_SAVING, payload: true });

  try {
    const { data } = await marginChangeRequestApi.approve(marginChangeRequestId, note);

    dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.RESOLVE_CHANGE_REQUEST, payload: data });

    return data;
  } catch (error) {
    dispatch({
      type: CHANGE_REQUEST_ACTION_TYPE.SET_DECISION_ERROR,
      payload: extractErrorMessage(error),
    });

    return null;
  }
};

export const rejectChangeRequestAction = (marginChangeRequestId, note) => async dispatch => {
  dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.SET_DECISION_SAVING, payload: true });

  try {
    const { data } = await marginChangeRequestApi.reject(marginChangeRequestId, note);

    dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.RESOLVE_CHANGE_REQUEST, payload: data });

    return data;
  } catch (error) {
    dispatch({
      type: CHANGE_REQUEST_ACTION_TYPE.SET_DECISION_ERROR,
      payload: extractErrorMessage(error),
    });

    return null;
  }
};

export const clearChangeRequestDecisionErrorAction = () => dispatch =>
  dispatch({ type: CHANGE_REQUEST_ACTION_TYPE.CLEAR_DECISION_ERROR });
